import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostRechnungRunterzaehlenCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostRechnungRunterzaehlenCommandService],
  exports: []
})
export class PostRechnungRunterzaehlenCommandServiceModule { }
